import { render } from "./NewDeal.vue?vue&type=template&id=3ada7554"
import script from "./NewDeal.vue?vue&type=script&lang=js"
export * from "./NewDeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__